<form [formGroup]="createForm" class="form-validation" (ngSubmit)="onSubmit()">
    <div class="modal-header">
      <h4 class="modal-title pull-left">{{ modalTitle }}</h4>
      <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body">

    <div class="row">

      <ng-template #ErrorMsg let-msg="msg" let-value="value" let-submitted="submitted">
        <div *ngFor="let validation of msg">
          <div class="error-message"
            *ngIf="value.hasError(validation.type) && (value.touched || value.dirty || submitted)">
            {{validation.message}}
          </div>
        </div>
      </ng-template>
      
    
      <div class="form-group col-sm-12">
        <label>Choose the Certificate</label>
        <select class="form-control" formControlName="language_id" [value]="1">
          <option value="1">English</option>
          <option value="2">Italian</option>
        </select>
      </div>


    </div>
  </div>

  <div class="modal-footer">
    <button type="submit" class="btn btn-success">Submit</button>
  </div>
</form>
